import { PLACEHOLDER_MESSAGES } from '@/utilities/constants/placeholder';
import { DefaultLogo } from '@/features/Logos/DefaultLogo';
import MainLoader, {
  MainLoaderProps,
} from '@/features/LoadingScreen/anexes/MainLoader';
import { useLoadingErrorPopup } from '@/features/LoadingScreen/useLoadingErrorPopup';
import { LocationNote } from '@/geolocation/screens/GeolocationHelperNotes';

const DefaultLoadingScreen = ({
  type,
  onAnimationFinish,
  isStuckedLoading,
  isDefault,
  isBottomBanner,
}: MainLoaderProps) => {
  useLoadingErrorPopup(type);

  if (isBottomBanner) return null;

  return (
    <>
      <div className="loading-screen__logo-slot" aria-hidden>
        <div className="loading-screen__logo-slot-background">
          <DefaultLogo />
        </div>
      </div>
      <div
        className={`loading-screen__loader-slot  ${isDefault ? 'default' : 'overlay'}`}
      >
        <MainLoader
          type={type}
          onAnimationFinish={onAnimationFinish}
          isStuckedLoading={isStuckedLoading}
        />
      </div>
      <p
        key={type}
        className={`loading-screen__text-slot game-client_placeholder-text ${isDefault ? 'default' : 'overlay'} ${type}`}
        data-testid="loading-screen-text"
      >
        {PLACEHOLDER_MESSAGES[type]}
      </p>
      <div
        className={`loading-screen__status-slot ${isDefault ? 'default' : 'overlay'}`}
      >
        <LocationNote />
      </div>
    </>
  );
};

export default DefaultLoadingScreen;
